/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {TwoColorIconProps} from '../IconTypes';

/**
 * ![CircleCheckIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABvElEQVR4nMWVz07CQBDGGy/qTTii8Q38c/GgF008CLQ7u4RsZ4KJiA+hBuMjibyGGvUoxpt6EE0UwbtmKtKWFmiL0U022UP7m535Zr41jP9cWus0KNoDSXWhqAEKP3h3z6cAdsU0S6kk4GlQeAQK30HR57AtJLWExCr/EwkOQBmQdD4KDP2BFF5blp4fCi8UtudA0WNcOPSywQfT1LODyyLpMikc3Ewu1svlqUAAIfF4XDj0Nh723z4dRVCIXCpq+brLacVkN30xpb0lJB6E6LHrBpBUjw2X9JzP62XDMCY4SIgWNW8Gd3HhpmkvMZyDcCbBANTwCEyd34TDtw4dN4Cidv8HlmMDxQ0hsempazMriouj4N0M2t4MbgMBJG4yKJfTC6DwieF8jgIPlMgxrpAO+RGRwXHg3VKeePzHrgxow1fLslcYHAvOG+wd36DxcAzqdcvSq3lZXIsKFwrfpCzP9FtFNdmwUVgH7Qe8iA2KjWp8OJ6Fmh0vtlq23MRwRff8noTCXcEpw7eID8erkQ+Ot1xsuYOF9wvKNc9ms5OR4P6SlVLsis6cSLzh8Xdshc8Ka0JROdAtf72+AD2/3znDBIe3AAAAAElFTkSuQmCC)
 */
export const CircleCheckIcon = ({
  size = 'md',
  width,
  height,
  secondaryColor = 'transparent',
  secondaryColorClass = '',
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: TwoColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="10"
        fill={typeof secondaryColor === 'string' ? secondaryColor : secondaryColor.css}
        className={secondaryColorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22Zm5.7-13.3a1 1 0 0 0-1.4-1.4L10 14.58l-2.3-2.3a1 1 0 0 0-1.4 1.42l3 3a1 1 0 0 0 1.4 0l7-7Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
